import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import colors from 'hsl-shared-components/lib/Theme/colors';
import { Trans } from 'react-i18next';
import { formatPrice } from '../../../price';
import {
  getRelativeHeight,
  getRelativeWidth,
} from '../../../components/CardReader/CardReader';

const SeasonalTicketConfirmation = styled.div`
  position: absolute;
  top: ${getRelativeHeight(76)};
  left: ${getRelativeWidth(13)};
  right: ${getRelativeWidth(13)};
  bottom: ${getRelativeHeight(56)};
  color: ${colors.primary.hslGreyDark};
`;

const SeasonalTicketTitle = styled.div`
  position: absolute;
  top: -36.5%;
  left: 28.333333%;
  font-weight: 500;
  color: ${colors.primary.hslWhite};
`;

const SeasonalTicketZone = styled.div`
  position: absolute;
  font-size: 2em;
  font-weight: 700;
  top: ${getRelativeHeight(55)};
  right: 0;
  left: 0;
  text-align: center;
`;

const SeasonalTicketValidity = styled.div`
  position: absolute;
  font-size: 0.85em;
  top: ${getRelativeHeight(165)};
  right: 0;
  left: 0;
  text-align: center;
`;

const SeasonalTicketRemainingFundsTitle = styled.div`
  color: ${colors.primary.hslGreyDark};
  position: absolute;
  font-size: 0.85em;
  font-weight: 300;
  top: ${getRelativeHeight(296)};
  left: ${getRelativeWidth(109)};
`;

const SeasonalTicketRemainingFunds = styled.div`
  position: absolute;
  font-size: 0.85em;
  font-weight: 700;
  top: ${getRelativeHeight(296)};
  right: ${getRelativeWidth(105)};
`;

const Multiplier = styled.span`
  font-size: 0.75em;
  position: relative;
  top: -0.15em;
  font-weight: 100;
  margin: 0 0.3em 0 0.3em;
`;

const SeasonalTicketConfirmationScreen = ({
  zones,
  validityEndsAtString,
  remainingFunds,
}) => (
  <SeasonalTicketConfirmation>
    <SeasonalTicketTitle>
      <Trans i18nKey="Generic.seasonalTicket" />
    </SeasonalTicketTitle>
    <SeasonalTicketZone>
      1<Multiplier>x</Multiplier>
      {zones}
    </SeasonalTicketZone>
    <SeasonalTicketValidity>
      <Trans i18nKey="Generic.validityAbbr" />{' '}
      <strong>{validityEndsAtString}</strong>
    </SeasonalTicketValidity>
    <SeasonalTicketRemainingFundsTitle>
      <Trans i18nKey="Generic.valueRemaining" />
    </SeasonalTicketRemainingFundsTitle>
    <SeasonalTicketRemainingFunds>
      {formatPrice(remainingFunds)}
    </SeasonalTicketRemainingFunds>
  </SeasonalTicketConfirmation>
);

SeasonalTicketConfirmationScreen.propTypes = {
  zones: PropTypes.string.isRequired,
  validityEndsAtString: PropTypes.string.isRequired,
  remainingFunds: PropTypes.number.isRequired,
};

export default SeasonalTicketConfirmationScreen;
